define('casino/navigation',['jquery', 'all/hash-monitor', 'casino/lobby', 'casino/ingame', 'casino/info', 'casino/activity-feed', 'all/slidingContentNavigation'], function($, hashMonitor, lobby, ingame, casinoInfo, activity, slidingContentNavigation) {
	'use strict';

	var legacyGameMatcher = /\Wgid=(\d+).*$/;

	function onPageChange(event) {

		if(typeof(event) !== 'undefined') {
			if(slidingContentNavigation.isSlidingContentNavigation(event.originalEvent)){
				return;
			}
		}

		var hash = location.hash.substring(1);


		if (hash !== '') {
            showGamesOrLobby();
        } else {
            handleRedirect();
        }
	}

	function getSplitHash(hash, index) {
		return hash.split(';')[index];
	}

	/**
	 * @returns {Array} gameIds as read from hash (taken from location.hash), or empty array
	 */
	function getGameIdsFromHash(hash) {
		var gameIdPart = getSplitHash(hash, 0).toLowerCase();
		if(gameIdPart.slice(2,7) === 'game=' || gameIdPart.slice(2,8) === 'group=') {
			var gameIds = gameIdPart.slice(2).split(',');
			return gameIds;
		}
		return [];
	}

	function showGamesOrLobby() {

		var gameIds = getGameIdsFromHash(location.hash);
		var thereAreGamesToLoad = gameIds.length > 0;

		if (thereAreGamesToLoad) {
			loadGames(gameIds);
		} else {
            showLobby();
		}
	}

	function loadGames(gameIds) {
		lobby.hide();
		ingame.show();

		if(casinoInfo.isSmallScreen() && gameIds.length > 1) {
			location.hash = gameIds[0];
			return;
		}

		ingame.loadGames(gameIds);
	}

	function showLobby() {
		ingame.hide();
		lobby.show();
	}

	// handles cases with no #! hash part, including old style gid=XXX game linkage
	function handleRedirect() {
        var $startLink;
		if (legacyGameMatcher.test(location.search)) {
			var searchMatch = legacyGameMatcher.exec(location.search);
			var searchGameId = searchMatch[1];
			location.hash = '#!game=' + searchGameId;
		} else {
            if (lobby.isTopMenuLiveCasinoSelected) {
                $startLink = $('#casino-top-menu').find('li:nth-child(2) a');
            } else {
                $startLink = $('#casino-top-menu').find('li:first a');
            }
			var href = $startLink.prop('href');
			var hash = $startLink.prop('hash');
			redirectWithoutReloadIfPossible(href, hash);
		}
	}

	function redirectWithoutReloadIfPossible(href, hash) {
		if (onlyRedirectingHashPart(href, hash)) {
			location.hash = hash;
		} else {
			location.replace(href);
		}
	}

	function onlyRedirectingHashPart(href, hash) {
		return href === location.href + hash;
	}

	return {
		init: function() {
			hashMonitor.addListener(onPageChange);
			activity.init();
		}
	};
});

